// Event registry for FGv2. Names are the ONLY strings that reach the analytics
// provider — call sites use the camelCase key, so a rename here is a one-line change.
//
// Convention (mirrors u26's `u26_*` registry so both apps are troubleshot the same way):
//   u_feelgreat_<domain>_<past-tense action>
// Names describe user intent, never the component or handler that fired them.
export const analyticsEvents = {
    pageViewed: 'u_feelgreat_page_viewed',

    loginSubmitted: 'u_feelgreat_login_submitted',
    loginSucceeded: 'u_feelgreat_login_succeeded',
    loginFailed: 'u_feelgreat_login_failed',
    loginGeoBlocked: 'u_feelgreat_login_geo_blocked',
    logout: 'u_feelgreat_logout',

    signUpSubmitted: 'u_feelgreat_sign_up_submitted',
    signUpSucceeded: 'u_feelgreat_sign_up_succeeded',
    signUpDuplicateDetected: 'u_feelgreat_sign_up_duplicate_detected',
    signUpFailed: 'u_feelgreat_sign_up_failed',

    cartItemAdded: 'u_feelgreat_cart_item_added',
    cartItemQuantityChanged: 'u_feelgreat_cart_item_quantity_changed',
    cartItemRemoved: 'u_feelgreat_cart_item_removed',
    cartLimitBlocked: 'u_feelgreat_cart_limit_blocked',
    cartSyncFailed: 'u_feelgreat_cart_sync_failed',
    cartCheckoutClicked: 'u_feelgreat_cart_checkout_clicked',

    checkoutSessionStarted: 'u_feelgreat_checkout_session_started',
    checkoutSessionFailed: 'u_feelgreat_checkout_session_failed',
    checkoutReferralRejected: 'u_feelgreat_checkout_referral_rejected',
    checkoutFormatLoadFailed: 'u_feelgreat_checkout_format_load_failed',
    checkoutShippingMethodChanged: 'u_feelgreat_checkout_shipping_method_changed',
    checkoutShippingSubmitted: 'u_feelgreat_checkout_shipping_submitted',
    checkoutShippingFailed: 'u_feelgreat_checkout_shipping_failed',
    checkoutAccountCreated: 'u_feelgreat_checkout_account_created',
    checkoutAccountFailed: 'u_feelgreat_checkout_account_failed',

    checkoutPurchaseClicked: 'u_feelgreat_checkout_purchase_clicked',
    checkoutPurchaseValidationError: 'u_feelgreat_checkout_purchase_validation_error',
    checkoutDuplicateDetected: 'u_feelgreat_checkout_duplicate_detected',
    checkoutPaymentCreateStarted: 'u_feelgreat_checkout_payment_create_started',
    checkoutPaymentCreateFailed: 'u_feelgreat_checkout_payment_create_failed',
    checkoutPaymentNextActionReceived: 'u_feelgreat_checkout_payment_next_action_received',
    checkoutPaymentPollingStarted: 'u_feelgreat_checkout_payment_polling_started',
    checkoutPaymentResultReceived: 'u_feelgreat_checkout_payment_result_received',
    checkoutPaidNoOrderDetected: 'u_feelgreat_checkout_paid_no_order_detected',
    checkoutPurchaseCompleted: 'u_feelgreat_checkout_purchase_completed'
} as const

export type AnalyticsEventKey = keyof typeof analyticsEvents
